export const extractAllBoldText = (value) => {
  if (!value) {
    return "";
  }

  return [...value.matchAll(/<b>(.*?)<\/b>/gi)].map((match) => match[1]).join(" ");
};
